var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"2207 741 5 8.3"}},[_c('path',{attrs:{"d":"M2211.627 748.214l-3.016-3.027 3.016-3.027a.573.573 0 1 0-.81-.81l-3.428 3.426a.57.57 0 0 0 0 .811l3.427 3.427a.573.573 0 1 0 .811-.81z","data-name":"Groupe 295"}})])};var toString = function () {return "/builds/agoulay/GUI-drivers/src/assets/svg/icon-chevron-left.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-chevron-left.svg
// module id = fGIV
// module chunks = 2